import { all } from 'redux-saga/effects';

import { watchFetchConsumerGroup } from './fetch';
import { watchResetConsumerGroup } from './reset';

export function* consumerGroupSaga() {
  yield all([watchFetchConsumerGroup(), watchResetConsumerGroup()]);
}
